export default "__VITE_ASSET__250d6cd0__"